import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  // withCredentials only makes sense in the browser (cookie-based auth)
  if (!isPlatformBrowser(platformId)) {
    return next(req);
  }

  // External URLs (e.g. Nominatim) return Access-Control-Allow-Origin: *,
  // which the browser rejects when withCredentials is true. In the browser
  // all internal API calls go through the dev proxy as relative paths (/api/…),
  // so any absolute URL here is definitively external.
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }

  return next(req.clone({ withCredentials: true }));
};
